import React, { useContext, useEffect, useState } from "react";
import embLabels from "../../config/emb-labels-en.json";
import Tooltip from "../../utils/Tooltip";
import { AssetBlockContext } from "../CustomHooks/ContextApi";
import LoadCbContactorDetails from "./LoadCbContactorDetails";
import { useSelector } from "react-redux";
import cbImage from "../../images/CB.png";

const GtAsset = ({
    configData,
    CBGTList,
    selectedValues,
    assetDetailsDisplay,
    setAssetSelection,
    gtChangeHandler,
    gtCbConfigChangeHandler,
    updateGtCb,
    closeGtConfigModal
  }) => {
  

   const assetInfo =
    CBGTList?.[selectedValues?.selectedGt]?.cbConfigData?.cbAssetDetails?.[0]
      ?.assetInfo;
  const setAssetHandler = () =>{
      closeGtConfigModal();
      setAssetSelection?.(embLabels.CIRCUIT_BREAKER);
    };
  const isMotorisedDisbaled = assetInfo === "Hardwired";

 const tooltipData = useSelector((state) => state?.tooltipData?.tooltipData);
  return (
    <>
    <div name="GT" className="col-md-12 p-0">

      <div className="col-md-12 mt-2  pt-1 se-white-background align-middle se-border">
        <div className="row">
          <label className=" col-md-5 bold mt-1 pt-2 se-font-14px">
            Asset Settings
          </label>
          <div className="col-md-7 mt-1 mb-1 text-right">
            <button
              type="button"
              className="btn btn-secondary btn-sm se-btn-secondary"
              onClick={updateGtCb}
            >
              <se-icon size="nano">action_save</se-icon>
              <span>&nbsp;</span>Save Settings
            </button>
          </div>
        </div>
      </div>
      <div className="col-md-12 pb-2 pt-2 se-grey-background">
        <div className="form-group mb-1">
          
          <label htmlFor="exampleFormControlInput1">
            Name <span className="se-mandatory">*</span>
          </label>
          <input
            type="text"
            autoComplete="none"
            className={"form-control form-control-sm "}
            id="exampleFormControlInput1"
            placeholder="Name"
            name="name"
            value={configData?.gtConfigData?.name}
            onChange={gtChangeHandler}
          />
          <div
            className="invalid-feedback-custom"
            style={!configData?.gtConfigData?.name ? {} : { display: "none" }}
          >
            {embLabels.nameRequired}
          </div>
        
          <div
            className="invalid-feedback-custom"
            style={configData?.gtConfigData?.name !==""  && !/^[a-zA-Z0-9-_ ]+$/.test(configData?.gtConfigData?.name )? {} : { display: "none" }}
          >
            {embLabels.notallowedAlphanumericValues}
          </div>
          
        </div>
        <div className="form-group mb-1">
          <label htmlFor="exampleFormControlInput1">Description</label>
          <input
            type="text"
            autoComplete="none"
            className="form-control form-control-sm"
            id="exampleFormControlInput1"
            placeholder="Description"
            name="description"
            value={configData?.gtConfigData?.description}
            onChange={gtChangeHandler}
          />
        </div>
      </div>
    </div>
    {/* Circuit Breaker Details */}
    <div name="Circuit_Breaker" className="col-md-12 p-0">
     
      <div className="col-sm-12 bold mt-2 mb-2">Circuit Breaker</div>
      <div className="col-md-12 col-sm-12 pt-2 pb-2 se-grey-background se-border">
        <div className="row">
          <div className="col-md-3">
            <img
              src={
                CBGTList?.[selectedValues?.selectedGt]?.cbConfigData?.cbAssetDetails?.[0]?.imageLink === null
                  ? cbImage
                  : CBGTList?.[selectedValues?.selectedGt]?.cbConfigData
                      .cbAssetDetails?.[0]?.imageLink
              }
              className="asset-image-display"
              alt="circuit breaker"
            />
          </div>
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-12 bold text-uppercase">
                Schneider Electric
              </div>
              <div className="col-md-12">
                {assetDetailsDisplay?.communicationModel ||
                  CBGTList?.[selectedValues?.selectedGt]?.cbConfigData?.cbAssetDetails?.[0]?.assetInfo ||
                  "PowerPact NSX"}
                <Tooltip
                  position="right"
                  iconColor="secondary"
                  information={
                    assetDetailsDisplay?.communicationModel ||
                    CBGTList?.[selectedValues?.selectedGt]?.cbConfigData?.cbAssetDetails?.[0]?.communicationModel ||
                    "PowerPact NSX"
                  }
                />
              </div>
            </div>
          </div>

          <div
            className=" col-md-3 col-sm-3 col-lg-3 text-center d-flex align-items-center"
            
          >
            <se-button option="outline" size="small" onClick={setAssetHandler}>
              Asset Selection
            </se-button>
          </div>
        </div>
      </div>
     
      <div className="col-md-12 se-grey-background pb-2">
        <div className="form-group mb-1 mt-2">
          <label htmlFor="exampleFormControlInput1">
            Name <span className="se-mandatory">*</span>
          </label>
          <input
            type="text"
            autoComplete="none"
            className={"form-control form-control-sm "}
            id="exampleFormControlInput1"
            placeholder="Name"
            name="name"
            value={configData?.cbConfigData?.name}
            onChange={gtCbConfigChangeHandler}
          />

          <div
            className="invalid-feedback-custom"
            style={!configData?.cbConfigData?.name ? {} : { display: "none" }}
          >
            {embLabels.nameRequired}
          </div>
          {(
            <div
              className="invalid-feedback-custom"
              style={
                configData?.cbConfigData?.name !== "" &&
                !/^[a-zA-Z0-9-_ ]+$/.test(configData?.cbConfigData?.name)
                  ? {}
                  : { display: "none" }
              }
            >
              {"Invalid Name"}
            </div>
          )}
        </div>

        <div className="form-group mb-1">
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              className="custom-control-input asCompatible"
              name="motorized"
              id="customControlValidation4"
              onChange={()=>undefined}
              value={configData?.cbConfigData?.motorized}
              checked={configData?.cbConfigData?.motorized}
            />
            <label
              className="custom-control-label line-height-25"
              htmlFor="customControlValidation4"
            >
              Motorized Circuit Breaker
            </label>
            {configData?.cbConfigData?.motorized}
            <Tooltip
              position="right"
              iconColor="secondary"
              iconSize="small"
              information={tooltipData?.motorized?.data}
            />
          </div>
        </div>

        {isMotorisedDisbaled &&(
            <div className="custom-control custom-checkbox">
              <input
                type="checkbox"
                className="custom-control-input asCompatible"
                name="contactor"
                id="customControlValidation45"
                // value={checked()}
                // checked={checked()}
                // onChange={contactorChangeHandler}
              />
              <label
                className="custom-control-label line-height-25"
                htmlFor="customControlValidation45"
              >
                Circuit Breaker + Contactor
              </label>
            </div>
          )}

        <div className="form-group mb-1">
          <label htmlFor="exampleFormControlInput1">Description</label>
          <input
            type="text"
            autoComplete="none"
            className="form-control form-control-sm"
            id="exampleFormControlInput1"
            placeholder="Description"
            name="description"
            value={configData?.cbConfigData?.description}
            onChange={gtCbConfigChangeHandler}
          />
        </div>
      </div>
      { CBGTList?.[selectedValues?.selectedLoad]?.uiData?.contactor &&
        isMotorisedDisbaled && (
          <LoadCbContactorDetails
            loadData={loadData}
          />
        )}
    </div>
    </>
  );
};

export default GtAsset;
